exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resources_from_LeadResources-css_Gyu {\r\n  position: relative;\r\n}\r\n\r\n.list_from_LeadResources-css_3v8 {\r\n  margin: 0 32px\r\n}\r\n\r\n.list_from_LeadResources-css_3v8 .noResources_from_LeadResources-css_17E {\r\n  font-size: 0.7em;\r\n  font-weight: 400;\r\n  color: #6F7583;\r\n}\r\n\r\n.upload_from_LeadResources-css_1Bq {\r\n  position: relative;\r\n  margin: 0 32px;\r\n  margin-top: 24px;\r\n  margin-bottom: 32px;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"resources": "resources_from_LeadResources-css_Gyu",
	"list": "list_from_LeadResources-css_3v8",
	"noResources": "noResources_from_LeadResources-css_17E",
	"upload": "upload_from_LeadResources-css_1Bq"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/sales/Lead/Resources/LeadResources.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/sales/Lead/Resources/LeadResources.css
// module chunks = 0